import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import LeftArrowPanel from "assets/icons1/left-arrow-panel.svg";
import SpamCheck from "./SpamCheck";
import SubjectLineHelper from "./SubjectLineHelper";
import SpamCheckerIcon from "assets/images/spam-checker.svg";
import SubjectLineHelperIcon from "assets/images/subject-line-helper.svg";

const options = [
  {
    label: "Spam Check",
    icon: <img src={SpamCheckerIcon} />,
    activeIcon: "",
    key: "spam-check",
  },
  {
    label: "Subject Line Helper",
    icon: <img src={SubjectLineHelperIcon} />,
    activeIcon: "",
    key: "subject-line-helper",
  },
  // {
  //   label: "Write with AI Assistant",
  //   icon: <AutoAwesomeIcon />,
  //   activeIcon: "",
  //   key: "write-with-ai-assistant",
  // },
];

interface CustomProps {
  exportPlainText: Function;
  exportHTML: Function;
  editorLoaded: boolean;
}

const AIPanel = (props: CustomProps) => {
  const [panelExpanded, setPanelExpanded] = useState<boolean>(true);
  const [activeMailzzyAIComponent, setActiveMailzzyAIComponent] =
    useState<string>("spam-check");

  const panelContent = () => {
    switch (activeMailzzyAIComponent) {
      case "spam-check": {
        return <SpamCheck exportPlainText={props.exportPlainText} />;
      }
      case "subject-line-helper": {
        return (
          <SubjectLineHelper
            exportPlainText={props.exportPlainText}
            exportHTML={props.exportHTML}
          />
        );
      }
      default: {
        return <SpamCheck exportPlainText={props.exportPlainText} />;
      }
    }
  };

  return (
    <Stack
      direction="row"
      sx={{
        display: props.editorLoaded ? "inherit" : "none",
      }}
    >
      <Stack
        sx={{
          position: "relative",
          width: panelExpanded ? "275px" : "0px",
          backgroundColor: "#f9f9f9",
          borderLeft: panelExpanded ? "1px solid rgb(212, 212, 212)" : "none",
          boxShadow: "rgb(212, 212, 212) 1px 0px 0px 0px",
          transition: "width 0.2s ease",
        }}
        p={panelExpanded ? 2 : 0}
      >
        {panelExpanded && panelContent()}
        <Stack
          sx={{
            position: "absolute",
            left: "-6%",
            bottom: "10%",
            transform: "rotate(180deg)",
            background: "#f9f9f9",
            borderRadius: "50%",
            boxShadow: "rgba(0, 0, 0, 0.12) 5px 5px 20px",
            cursor: "pointer",
            "&:hover": { background: "rgb(244, 244, 244)" },
            border: "1px solid rgb(238, 238, 238)",
          }}
          p={0.65}
          onClick={() => setPanelExpanded(!panelExpanded)}
        >
          <KeyboardDoubleArrowLeftIcon
            fontSize="small"
            htmlColor="rgb(81, 81, 81) !important"
          />
        </Stack>
      </Stack>
      <Stack
        sx={{
          position: "relative",
          backgroundColor: "#d4d4d4",
          width: "85px",
          height: "100%",
          borderLeft: "1px solid rgb(212, 212, 212)",
        }}
      >
        <Stack>
          {options.map((option) => {
            const isSelected = activeMailzzyAIComponent === option.key;
            return (
              <>
                <Stack
                  position="relative"
                  spacing={1}
                  alignItems="center"
                  textAlign="center"
                  p={1}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: isSelected ? "#f9f9f9" : "transparent",
                    "&:hover": {
                      backgroundColor: isSelected
                        ? "#f9f9f9"
                        : "rgb(192, 197, 201)",
                    },
                  }}
                  onClick={() => {
                    setActiveMailzzyAIComponent(option.key);
                    setPanelExpanded(true);
                  }}
                >
                  {option.icon}
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                    }}
                  >
                    {option.label}
                  </Typography>
                  {panelExpanded && isSelected && (
                    <Box
                      sx={{
                        position: "absolute",
                        left: "-11%",
                        bottom: "40%",
                        transform: "rotate(180deg)",
                      }}
                    >
                      <img src={LeftArrowPanel} />
                    </Box>
                  )}
                </Stack>
              </>
            );
          })}
        </Stack>
        {!panelExpanded && (
          <Stack
            sx={{
              position: "absolute",
              left: "-20%",
              bottom: "10%",
              // transform: "rotate(180deg)",
              background: "#f9f9f9",
              borderRadius: "50%",
              boxShadow: "rgba(0, 0, 0, 0.12) 5px 5px 20px",
              cursor: "pointer",
              "&:hover": { background: "rgb(244, 244, 244)" },
              border: "1px solid rgb(238, 238, 238)",
            }}
            p={0.65}
            onClick={() => setPanelExpanded(!panelExpanded)}
          >
            <KeyboardDoubleArrowLeftIcon
              fontSize="small"
              htmlColor="rgb(81, 81, 81) !important"
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default AIPanel;
